import ApiService from '@/services/core/api.service'

const PromotionService = {
  async get (query) {
    return ApiService.get(`supervisor/promotions?${query}`)
  },

  async post (payload) {
    return ApiService.post('supervisor/promotions', payload)
  },

  async put (payload) {
    return ApiService.put(`supervisor/promotions/${payload.id}`, payload)
  }
}

export default PromotionService
